import { Paragraph } from '@eggplant/pattern-library'

const NotificationRecipientsDescription = () =>
  <Paragraph>
    Only users with verified emails are listed here.
  </Paragraph>

export default NotificationRecipientsDescription
